export default __webpack_public_path__ + "static/media/structure.59d8e1b7.md";